
import styled from '@emotion/styled';

export const ChannelsCheckboxesWrapper = styled('div', { label: 'ChannelsCheckboxesWrapper' })`
    margin-bottom: 25px;
`;

export const ChannelWrapper = styled('div', { label: 'ChannelWrapper' })`
    display: flex;
    justify-content: flex-start;
`;

export const ChannelCheckbox = styled('div', { label: 'ChannelCheckbox' })`
    width: 200px;
`;
